import React from "react";
import "../App.css";
import "../styles/layout.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Chart from "../components/Chart";
import "./Monitoring.css";

const Monitoring = () => {
  return (
    <div className="app-shell">
      <Navbar />
      <main className="app-main">
        <div className="monitoring-page">
          <div className="monitoring-card">
            <div className="monitoring-card__header">
              <div>
                <h1 className="monitoring-card__title">Monitoring</h1>
                <p className="monitoring-card__subtitle">
                  Track connection for each live channel
                </p>
              </div>
            </div>
            <div className="monitoring-card__body">
              <Chart />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Monitoring;
